export default {
  loadingWebsites: "Chargement des sites ...",
  website: "Site internet",
  websiteLoading: "Chargement des organismes",
};
